import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { Flex, KeyboardBadge, token } from '@bynder/design-system';

const clientOS = navigator.userAgent.toLowerCase();
const isCommandKey = clientOS.includes('mac');

// TODO: Temporary, will be fixed in DS or changed later
// eslint-disable-next-line rulesdir/design-system-no-flex-component-wrapping
const StyledWrapper = styled(Flex)`
    kbd {
        box-shadow: none;
        color: ${token.gray600};
    }
`;

const shortcutsSymbols = {
    cmd: '⌘',
    ctrl: '⌃',
    opt: '⌥',
    alt: 'alt',
};

export const parseShortcutForTooltip = (shortcut: string[]) => {
    return shortcut.reduce((accum, cur) => {
        let btn = cur;

        if (btn === 'cmd' || btn === 'ctrl') {
            btn = isCommandKey ? shortcutsSymbols.cmd : shortcutsSymbols.ctrl;
        } else if (btn === 'opt' || btn === 'alt') {
            btn = isCommandKey ? shortcutsSymbols.opt : shortcutsSymbols.opt;
        }

        return accum + (btn.length > 1 ? btn : btn.toUpperCase());
    }, '');
};

export const WithShortcutLabel = ({ children, shortcut }: { children: ReactNode; shortcut: string[] }): ReactNode => {
    return (
        <Flex justifyContent="space-between" alignItems="center" gap="6">
            <div>{children}</div>
            <StyledWrapper gap="3" justifyContent="flex-end">
                <KeyboardBadge>{parseShortcutForTooltip(shortcut)}</KeyboardBadge>
            </StyledWrapper>
        </Flex>
    );
};
